// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'mail';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M1.563 3.865h14.874V14.49H1.563z' />
    <path d='M16.197 4.254 10.43 8.691a2.343 2.343 0 0 1-2.858 0L1.803 4.254' />
  </g>
);

export const viewBox = '0 0 18 18';
